/** Mailbox providers whose domain says nothing about the user's company. */
const FREEMAIL_DOMAINS = new Set([
  'gmail.com',
  'googlemail.com',
  'outlook.com',
  'hotmail.com',
  'live.com',
  'yahoo.com',
  'icloud.com',
  'me.com',
  'aol.com',
  'proton.me',
  'protonmail.com',
  'gmx.com',
  'hey.com',
  'fastmail.com',
]);

/**
 * The prefilled "Workspace name" on the signup screen: the capitalized domain
 * label of a company email (`ada@acme.com` → "Acme"), otherwise
 * "<display name>'s workspace". The user edits it before anything is created.
 */
export function suggestWorkspaceName(email: string | null, displayName: string | null): string {
  const domain = email?.split('@')[1]?.toLowerCase();
  if (domain && !FREEMAIL_DOMAINS.has(domain)) {
    const label = domain.split('.')[0] ?? '';
    if (label) return label.charAt(0).toUpperCase() + label.slice(1);
  }
  const first = displayName?.trim() || email?.split('@')[0]?.trim();
  return first ? `${first}'s workspace` : 'My workspace';
}
